import { Component, ElementRef, forwardRef, Input, OnInit, ViewChild } from "@angular/core";
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from "@angular/forms";
import { SharedModule } from "../../modules/shared/shared.module";
import { ICellEditorAngularComp } from "ag-grid-angular";
import { ICellEditorParams } from "ag-grid-community";
import { NgIf } from "@angular/common";
import { GridTableService } from "../../services/grid-table.service";
import { NzSwitchComponent } from "ng-zorro-antd/switch";
import { of } from "rxjs";

@Component({
  selector: "app-input",
  standalone: true,
  templateUrl: "./input.component.html",
  styleUrl: "./input.component.scss",
  imports: [
    NgIf,
    FormsModule,
    NzSwitchComponent
  ],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => InputComponent),
    multi: true
  }]
})
export class InputComponent implements OnInit, ControlValueAccessor, ICellEditorAngularComp {
  value: any;
  agGridParam: any

  @Input() label: string = "";
  @Input() inputType: string = "text";
  @Input() id: string = "";
  @Input() name: string = "";
  @Input() placeholder: string = "Enter value";
  @Input() disable: boolean = false;

  @ViewChild("inputElement") inputElement!: ElementRef<HTMLInputElement>;

  constructor(private gridTableService: GridTableService) {
  }


  ngOnInit() {
  }

  onChange: (value: any) => void = () => {
  };
  onTouched: () => void = () => {
  };

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(obj: any): void {
    this.value = obj;
    this.onChange(this.value);
  }

  setDisabledState(isDisabled: boolean): void {
    this.disable = isDisabled;
  }

  agInit(params: ICellEditorParams): void {
    this.agGridParam = params;
    Object.keys(params).forEach((k: string) => {
      if ((this as any).hasOwnProperty(k)) {
        (this as any)[k] = (params as any)[k];
      }
    });
    this.writeValue(params.value);
  }

  afterGuiAttached() {
    setTimeout(() => {this.inputElement.nativeElement.focus()},0)
  }

  getValue(): any {
    return this.value
  }

  getValidationErrors(): string[] | null {
    return this.gridTableService.validateEditableGrid(this.agGridParam.col, this.value);
  }

  validateAgGird() {
    this.agGridParam?.validate?.();
  }
}
